import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ItemNumber } from '../models/item-number';

@Injectable({
  providedIn: 'root'
})
export class ItemNumberApiService {

  private apiBaseUrl = `${environment.apiUrl}itemNumber`;

  constructor(private httpClient: HttpClient) { }

  public getByContractDetails(contractDetailsId: number): Observable<ItemNumber[]> {
    return this.httpClient.get<ItemNumber[]>(`${this.apiBaseUrl}/byContractDetails/${contractDetailsId}`);
  }

  public post(itemNumber: ItemNumber): Observable<ItemNumber> {
    return this.httpClient.post<ItemNumber>(this.apiBaseUrl, itemNumber);
  }

  public patch(itemNumber: ItemNumber): Observable<ItemNumber> {
    return this.httpClient.patch<ItemNumber>(this.apiBaseUrl, itemNumber);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiBaseUrl}/${id}`);
  }
}
